import React from 'react'

export default function QuestionMarkCircleIcon ({ ...props }) {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100.12 100.12'>
      <path d='M50.06,100.12a50.06,50.06,0,1,1,50.06-50.06A50.12,50.12,0,0,1,50.06,100.12ZM50.06,5A45.06,45.06,0,1,0,95.12,50.06,45.11,45.11,0,0,0,50.06,5Z' />
      <path d='M64.15,24.22q5.22,4.44,5.22,12.66c0,4.81-1.59,8.6-4.78,11.4S57.19,52.53,52,52.63l-.39,5.78H37.88L37.4,42.66h5.7a21.54,21.54,0,0,0,8.23-1.23A4.4,4.4,0,0,0,54.18,37,4.71,4.71,0,0,0,53,33.68a4.06,4.06,0,0,0-3.12-1.23,4.26,4.26,0,0,0-3.37,1.31,5.16,5.16,0,0,0-1.14,3.52H30.76a16.88,16.88,0,0,1,2-8.82,15.51,15.51,0,0,1,6.61-6.33A23.2,23.2,0,0,1,50.3,19.79Q58.93,19.79,64.15,24.22ZM38.24,78.07a7.36,7.36,0,0,1-2.5-5.74,7.48,7.48,0,0,1,2.5-5.77,9.36,9.36,0,0,1,6.6-2.3,9.26,9.26,0,0,1,6.53,2.3,7.85,7.85,0,0,1,0,11.47,9.26,9.26,0,0,1-6.53,2.3A9.43,9.43,0,0,1,38.24,78.07Z' />
    </svg>
  )
}
